module.exports = __webpack_public_path__ + "static/img/butterflies.14aa7b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/butterflies.png
// module id = tslc
// module chunks = 0